"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _ossUpload = require("@/utils/ossUpload");
var _appSetting = require("@/api/appSetting");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  data: function data() {
    return {
      list: [{
        info: '20x20',
        url: ''
      }, {
        info: '29x29',
        url: ''
      }, {
        info: '40x40',
        url: ''
      }, {
        info: '58x58',
        url: ''
      }, {
        info: '60x60',
        url: ''
      }, {
        info: '72x72',
        url: ''
      }, {
        info: '76x76',
        url: ''
      }, {
        info: '80x80',
        url: ''
      }, {
        info: '87x87',
        url: ''
      }, {
        info: '96x96',
        url: ''
      }, {
        info: '120x120',
        url: ''
      }, {
        info: '144x144',
        url: ''
      }, {
        info: '152x152',
        url: ''
      }, {
        info: '167x167',
        url: ''
      }, {
        info: '180x180',
        url: ''
      }, {
        info: '192x192',
        url: ''
      }, {
        info: '1024x1024',
        url: ''
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;
    (0, _appSetting.getManifest)({
      type: 'appIcon'
    }).then(function (res) {
      if (res.data) {
        _this.list = JSON.parse(res.data);
      }
    });
  },
  methods: {
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(file, item) {
        var pictureUrl;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              console.log(file.file, item);
              _context.n = 1;
              return (0, _ossUpload.uploadOSS)(file.file, 'builds', item.info + '.png');
            case 1:
              pictureUrl = _context.v;
              item.url = pictureUrl + '?pic=' + Math.random();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      function handleFileUpload(_x, _x2) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    save: function save() {
      var _this2 = this;
      this.$confirm('确认是否要保存？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _appSetting.saveManifest)({
          appIcon: JSON.stringify(_this2.list, null, 2)
        }).then(function (res) {
          if (res.data) {
            _this2.$notify.success({
              title: '温馨提示',
              message: '操作成功！'
            });
          }
        });
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消'
        });
      });
    }
  }
};